import React, { useEffect, useState } from "react";
import TextEditor from "./AdminFAQ/widgets/TextEditor";
import { Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editAgreement,
  fetchAgreement,
} from "../../redux/actions/agreement_actions";
import Loading from "../../components/Loading";
import styled from "styled-components";

const AdminAgreement = () => {
  const [content, setContent] = useState(
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sagittis purus neque, eu tincidunt leo mattis at. Duis vel fringilla risus. Donec fringilla varius est, sit amet accumsan ligula dapibus in. Vivamus sollicitudin sapien vel hendrerit ullamcorper. Morbi sit amet euismod dui, eu facilisis mi. Praesent porta neque id mattis mollis. Suspendisse congue tincidunt laoreet. Nulla aliquam vitae nisl ut dapibus. Pellentesque cursus, sapien sed vestibulum ullamcorper, eros nisi laoreet dolor, id gravida est ligula non quam. Vivamus eu lorem sed neque posuere tempus. Praesent non tortor dapibus, sagittis nibh a, consectetur ipsum Etiam et luctus tellus. Sed tempus, lorem quis aliquam dignissim, neque elit tincidunt sem, sit amet scelerisque ligula elit sed risus. Vestibulum cursus augue sed tortor cursus malesuada. Nulla tristique cursus venenatis. Integer eleifend auctor ligula, et luctus massa lobortis vitae. In malesuada gravida elit, ac pretium nulla auctor eu. Praesent non lorem risus. Mauris diam ante, sollicitudin vitae risus quis, maximus vulputate orci. Sed tincidunt cursus magna, eget mattis orci iaculis vel. Quisque non arcu hendrerit, tincidunt odio nec, aliquet nisi. Donec vitae mauris arcu. Maecenas ac ligula sit amet dolor laoreet auctor nec dapibus justo. Quisque massa nulla, feugiat vitae porttitor rutrum, aliquam ac erat. Nunc id mollis velit, quis tincidunt sapien. Donec sollicitudin odio libero, vitae scelerisque est pretium bibendum. Fusce sagittis massa ut dapibus scelerisque. Nulla eros magna, elementum a tristique ut, semper eget felis. Fusce lacus libero, varius at turpis sit amet, elementum bibendum nunc. Quisque rhoncus orci augue, ac pulvinar purus auctor ac. Nunc non metus ex. Suspendisse aliquet ligula id purus finibus, sed condimentum nisl aliquam. Morbi mauris lacus, volutpat ut lobortis tincidunt, aliquam eu ipsum. Pellentesque lobortis facilisis gravida.Ut vitae lorem dolor. Ut non fermentum justo, a sodales nunc. Pellentesque commodo mattis molestie. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vivamus est turpis, porta sit amet gravida eu, laoreet vitae libero. Suspendisse malesuada tincidunt nulla id consequat. Vivamus pretium accumsan metus eget ultrices. Vestibulum vitae fermentum dui. Vestibulum ut urna quis orci hendrerit porta eu eu erat. Duis nunc neque, tincidunt vitae nulla id, rutrum lobortis nisi. Vestibulum semper sagittis augue, a suscipit leo aliquet sit amet. Duis ullamcorper rhoncus nunc, cursus consectetur orci lobortis non. Vivamus hendrerit leo nibh, vel volutpat nulla pellentesque eget. Duis dapibus lacus libero, vel gravida enim aliquam et. Nam hendrerit bibendum ligula, non congue magna condimentum et. Curabitur risus felis, pellentesque vitae augue sed, interdum interdum nunc."
  );
  const [lastEditDate, setLastEditDate] = useState("");
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(
    (state) => state.auth_reducers.auth_credentials.token
  );
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      let response = await dispatch(fetchAgreement());
      setContent(response && response.agreement);
      setLastEditDate(response && response.updatedAt);
      setId(response && response._id);
      setLoading(false);
    };
    getData();
  }, [dispatch]);

  const handlePublish = async () => {
    setPublishing(true);
    await dispatch(
      editAgreement(
        {
          agreementId: id && id,
          agreement: content,
        },
        token
      )
    );
    setPublishing(false);
    setSaved(true);
    setTimeout(() => {
      setSaved(false);
    }, 5000);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Wrapper className="agreement mb-5">
      <div className="col-lg-12">
        <h1>Fleetsimplify Agreement</h1>
        {/* <p className="my-4">
          Upload here Fleetsimplify agreement in a pdf file format
        </p> */}
        <p className="my-4">Type agreement here</p>
      </div>

      {/* <div className="col-lg-7">
        <form>
          <div className="upload-file d-flex">
            <input
              type="file"
              id="agreement"
              hidden
              accept="application/pdf, .pdf"
            />
            <label
              htmlFor="agreement"
              className="file-btn font-16 br-0"
            >
              Choose a file
            </label>
            <span className="upload-file-text">No file chosen yet</span>
          </div>
        </form>
      </div> */}
      <Row className="mb-4">
        <Col className="text-right">
          Last updated on{" "}
          {lastEditDate && new Date(lastEditDate).toDateString()}
        </Col>
      </Row>
      <TextEditor content={content} setContent={setContent} />
      <div className="d-flex align-items-center h-100 mt-4">
        <Button
          className="w-8r"
          variant="dark"
          onClick={handlePublish}
          disabled={publishing}
        >
          {publishing ? "Publishing..." : "Publish"}
        </Button>
        {saved === true && (
          <span type="button" className="saved">
            Saved
            <span className="fa fa-check"></span>
          </span>
        )}
      </div>
    </Wrapper>
  );
};

export default AdminAgreement;

const Wrapper = styled.div`
  padding: 0 1rem;

  .ql-toolbar.ql-snow {
    background-color: #ffff;
  }
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    background: #ffff;
    border-top: 0px;
    min-height: 17rem;
  }
`;
